import _omit from 'lodash/omit';
import {
    ADD_INVITE_TABLE_DND_USERS,
    REMOVE_INVITE_TABLE_DND_USERS,
} from 'store/actions/inviteTableDndUsers';

const initialState = {};

function inviteTableDndUsers(state = initialState, action) {
    const { payload, type } = action;
    switch (type) {
        case ADD_INVITE_TABLE_DND_USERS:
            return { ...state, ...payload };
        case REMOVE_INVITE_TABLE_DND_USERS:
            return _omit(state, payload);
        default:
            return state;
    }
}

export default inviteTableDndUsers;
